export default "__VITE_ASSET__86550e3f__"